import React from "react";
import graph from "./graph";

import { CustomList } from "components";
import { useQuery } from "@apollo/client";
import { useSelector } from "react-redux";
import { isEmptyObject } from "helpers/formatObject";
import {
  Menu,
  Stack,
  IconButton,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Typography,
  CircularProgress,
} from "@mui/material";
import { addCommas } from "@persian-tools/persian-tools";
import EqualizerRoundedIcon from "@mui/icons-material/EqualizerRounded";
import { ContentCut } from "@mui/icons-material";

export default function Report({ filter = {}, title = "گزارش" }) {
  const { userToken } = useSelector((state) => state.auth);

  const [anchorEl, setAnchorEl] = React.useState(null);

  const { data, loading } = useQuery(graph.report.query, {
    variables: filter,
    skip: !anchorEl,
    context: {
      serviceName: graph.report.serviceName,
      headers: {
        authorization: `Bearer ${userToken}`,
      },
    },
  });

  const report = !isEmptyObject(data) ? data[graph.report.name] : {};

  return (
    <>
      <IconButton
        size="small"
        color="info"
        sx={{ bgcolor: "action.hover" }}
        onClick={(e) => setAnchorEl(e.currentTarget)}
      >
        <EqualizerRoundedIcon />
      </IconButton>
      <Menu
        dir="rtl"
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
        slotProps={{ list: { sx: { p: 1, minWidth: 200 } } }}
      >
        {/* <MenuItem>
          <ListItemIcon>
            <ContentCut fontSize="small" />
          </ListItemIcon>
          <ListItemText>تعداد کل</ListItemText>
          <Typography variant="body2" sx={{ color: "text.secondary" }}>
            {addCommas(+report?.count)}
          </Typography>
        </MenuItem> */}
        <Stack>
          {loading ? (
            <Stack
              rowGap={2}
              height="100%"
              alignItems="center"
              justifyContent="center"
            >
              <CircularProgress size={20} color="inherit" />
              <Typography
                align="center"
                variant="caption"
                color="text.disabled"
              >
                در حال محاسبه...
              </Typography>
            </Stack>
          ) : (
            <CustomList
              data={{
                title,
                // unit: "",
                // value: "",
                children: [
                  {
                    title: "تعداد کل",
                    value: addCommas(+report?.count),
                    unit: "نفر",
                  },
                ],
              }}
            />
          )}
        </Stack>
      </Menu>
    </>
  );
}
